import React, { useRef, useCallback, useState } from "react";
import {
  GoogleMap,
  Marker,
  InfoWindow,
  LoadScript,
} from "@react-google-maps/api";
import { useSelector } from "react-redux";

export default function MapView({ onPickLocation, disableDefaultUI }) {
  const userLocation = useSelector((state) => state.userLocation);

  const [lat, setLat] = useState(
    localStorage.getItem("lat")
      ? parseFloat(localStorage.getItem("lat"))
      : userLocation
      ? userLocation.location?.lat
      : 21.3891
  );
  const [lng, setLng] = useState(
    localStorage.getItem("lng")
      ? parseFloat(localStorage.getItem("lng"))
      : userLocation
      ? userLocation.location?.lng
      : 39.8579
  );
  console.log("lat", lat);
  console.log("lng", lng);

  const center = { lat, lng };

  const [map, setMap] = useState(null);
  const [activeMarker, setActiveMarker] = useState(null);

  const handleActiveMarker = (marker) => {
    if (marker === activeMarker) {
      return;
    }
    setActiveMarker(marker);
  };

  const onUnmount = useCallback(function callback(map) {
    setMap(null);
  }, []);

  return (
    <div style={{ width: "100%", overflowX: "hidden" }}>
      <LoadScript
        id="google-map-script-loader"
        googleMapsApiKey={"AIzaSyAGpL9qLO2D5V6ToKYEvAQZ7YymBRmB9Pk"}
        libraries={["places"]}
        loadingElement={<></>}
      >
        <GoogleMap
          id="map"
          mapContainerClassName="map-container"
          center={center}
          zoom={13.5}
          onUnmount={onUnmount}
          onClick={(e) => {
            if (disableDefaultUI) {
            } else {
              let latitude = e.latLng.lat();
              let longtitude = e.latLng.lng();
              console.log(latitude, longtitude);
              setLat(latitude);
              setLng(longtitude);
              onPickLocation(latitude, longtitude);
            }
          }}
        >
          <Marker
            // id={1}
            position={{
              lat: lat,
              lng: lng,
            }}
            // onClick={() => handleActiveMarker(1)}
          ></Marker>
        </GoogleMap>
      </LoadScript>
    </div>
  );
}
